import { render, staticRenderFns } from "./ModalContentAddUser.vue?vue&type=template&id=6c12a054&"
import script from "./ModalContentAddUser.vue?vue&type=script&lang=js&"
export * from "./ModalContentAddUser.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentAddUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports